export default __webpack_public_path__ + "static/media/topping_greycat.8ceda188.jpg";